import 'client-only'

import { getSession } from 'next-auth/react'

import type { Session } from 'next-auth'

let providedSession: { session: Session | null } | undefined
let cachedSessionPromise: Promise<Session | null> | null = null
let lastSessionTime = 0
const SESSION_CACHE_TTL = 30_000

export const provideSession = (session: Session | null) => {
  providedSession = { session }
}

const fetchSessionOnce = async (): Promise<Session | null> => {
  const now = Date.now()

  if (cachedSessionPromise && now - lastSessionTime < SESSION_CACHE_TTL) {
    return cachedSessionPromise
  }

  return refreshCachedSession()
}

// Bypasses the cache so NextAuth's `jwt()` callback re-checks and refreshes an expired token.
export const refreshCachedSession = async (): Promise<Session | null> => {
  cachedSessionPromise = getSession()
  lastSessionTime = Date.now()

  try {
    return await cachedSessionPromise
  } catch (error) {
    cachedSessionPromise = null
    throw error
  }
}

export const getCachedSession = async (): Promise<Session | null> => {
  return providedSession ? providedSession.session : fetchSessionOnce()
}
